module.exports = __webpack_public_path__ + "img/CO.ecd28ebe.png";